import React, { useState, useEffect } from "react";
import useScrollAnimation from "./useScrollAnimation";
import emailjs from "emailjs-com";

const Contact = () => {
  const [infoRef, infoVisible] = useScrollAnimation();
  const [formRef, formVisible] = useScrollAnimation();
  const [mapRef, mapVisible] = useScrollAnimation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showSocials, setShowSocials] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setShowSocials(false);
      } else {
        setShowSocials(true);
      }
      setLastScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_6qgpvwx",//"YOUR_SERVICE_ID",
        "template_cn9qz2b",//"YOUR_TEMPLATE_ID",
        formData,
        "zXoloAJSPJuiHNirt"//"YOUR_PUBLIC_KEY"
      )
      .then(
        (result) => {
          console.log("Email sent:", result.text);
          setIsSubmitted(true);
          setFormData({
            name: "",
            email: "",
            phone: "",
            subject: "",
            message: "",
          });
        },
        (error) => {
          console.error("Error:", error.text);
          alert("⚠️ Something went wrong, please try again later.");
        }
      );

    setTimeout(() => setIsSubmitted(false), 4000);
  };

  const socials = [
    {
      name: "Facebook",
      color: "bg-blue-600",
      hover: "bg-blue-700",
      link: "https://facebook.com",
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12z" />
        </svg>
      ),
    },
    {
      name: "Instagram",
      color: "bg-pink-600",
      hover: "bg-pink-700",
      link: "https://instagram.com",
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M7.75 2h8.5A5.75 5.75 0 0122 7.75v8.5A5.75 5.75 0 0116.25 22h-8.5A5.75 5.75 0 012 16.25v-8.5A5.75 5.75 0 017.75 2zm0 1.5A4.25 4.25 0 003.5 7.75v8.5A4.25 4.25 0 007.75 20.5h8.5a4.25 4.25 0 004.25-4.25v-8.5A4.25 4.25 0 0016.25 3.5h-8.5zM12 7a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm5.5-.875a1.125 1.125 0 11-2.25 0 1.125 1.125 0 012.25 0z" />
        </svg>
      ),
    },
    {
      name: "Twitter",
      color: "bg-blue-400",
      hover: "bg-blue-500",
      link: "https://twitter.com",
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23 3a10.9 10.9 0 01-3.14 1.53A4.48 4.48 0 0022.4 1a9.1 9.1 0 01-2.88 1.1 4.52 4.52 0 00-7.72 4.13 12.84 12.84 0 01-9.32-4.72 4.52 4.52 0 001.39 6.03A4.5 4.5 0 012 9.71v.06a4.52 4.52 0 003.63 4.43 4.52 4.52 0 01-2.04.08 4.108 4.108 0 003.834 2.85A9.05 9.05 0 012 19.54 12.78 12.78 0 008.29 21c7.55 0 11.68-6.25 11.68-11.67 0-.18 0-.35-.01-.53A8.36 8.36 0 0023 3z" />
        </svg>
      ),
    },
    {
      name: "YouTube",
      color: "bg-red-600",
      hover: "bg-red-700",
      link: "https://www.youtube.com/channel/UCvo01TQ6MJEmPBovOmOsX5A",
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19.615 3.184C21.403 3.5 22.5 4.543 22.5 6.267v11.466c0 1.724-1.097 2.767-2.885 3.083-2.615.5-13.23.5-15.846 0C1.097 20.5 0 19.457 0 17.733V6.267C0 4.543 1.097 3.5 2.885 3.184 5.5 2.684 16.115 2.684 18.731 3.184zM9.75 15.5V8.5l6 3.5-6 3.5z" />
        </svg>
      ),
    },
  ];

  // ✅ FIX: moved chatButtons outside return()
  const chatButtons = [
    {
      name: "WhatsApp",
      color: "bg-green-500",
      hover: "bg-green-600",
      link: "https://wa.me/2348138644342",
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12.004 2C6.478 2 2 6.478 2 12.004c0 1.915.49 3.788 1.423 5.44L2 22l4.685-1.392A9.93 9.93 0 0012.004 22C17.53 22 22 17.522 22 12.004 22 6.478 17.53 2 12.004 2zm0 18.4a8.45 8.45 0 01-4.316-1.188l-.308-.183-2.775.825.8-2.742-.184-.316A8.5 8.5 0 1112.004 20.4zm4.682-6.347c-.255-.128-1.507-.743-1.74-.826-.232-.086-.402-.128-.57.128-.167.255-.655.825-.803.993-.147.168-.295.19-.55.064-.255-.128-1.076-.397-2.05-1.266-.757-.676-1.27-1.51-1.418-1.765-.148-.255-.016-.393.112-.52.115-.114.255-.296.383-.443.128-.147.17-.255.255-.425.085-.17.043-.318-.021-.446-.064-.128-.57-1.373-.782-1.881-.206-.495-.416-.427-.57-.435l-.487-.009c-.17 0-.446.064-.68.318-.232.255-.89.87-.89 2.12 0 1.25.91 2.456 1.038 2.628.128.17 1.79 2.73 4.342 3.829.607.262 1.082.418 1.451.535.61.195 1.165.168 1.604.102.49-.073 1.507-.615 1.72-1.21.213-.596.213-1.107.149-1.212-.064-.106-.232-.17-.487-.298z" />
        </svg>
      ),
    },
    {
      name: "Messenger",
      color: "bg-blue-500",
      hover: "bg-blue-600",
      link: "https://m.me/yourpage",
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.486 2 2 6.117 2 11.3c0 2.92 1.41 5.545 3.672 7.288V22l3.355-1.865A10.68 10.68 0 0012 20.6c5.514 0 10-4.118 10-9.3S17.514 2 12 2zm.35 13.6l-2.663-2.826L5.5 15.6l4.86-5.17 2.643 2.807 4.235-2.807-4.888 5.17z" />
        </svg>
      ),
    },
  ];

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* ... Rest of your JSX stays exactly the same ... */}
      {/* Hero Section */}
      <div
        className="relative py-20 md:py-32 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/images/slides.png')`
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 opacity-0 animate-fadeIn">
            Contact Us
          </h1>
          <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto opacity-0 animate-fadeIn delay-300">
            Get in touch with us for inquiries, support, or more information about The Federal Polytechnic, Bida.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 flex flex-col lg:flex-row gap-8 md:gap-10">

        {/* Contact Information Card */}
        <div
          ref={infoRef}
          className={`w-full lg:w-2/5 bg-white rounded-3xl shadow-2xl p-6 md:p-10 transition-all duration-700 hover:shadow-3xl hover:-translate-y-1 ${
            infoVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {/* Card Header with Icon */}
          <div className="flex items-center gap-3 mb-6">
            <div className="bg-blue-100 text-blue-600 w-12 h-12 flex items-center justify-center rounded-full shadow-md">
              {/* You can replace this SVG with any other icon */}
              <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">Contact Information</h2>
          </div>

          {/* Info Items */}
          <div className="space-y-4 text-gray-700">
            <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-blue-50 transition-all duration-300 cursor-pointer transform hover:scale-105">
              <span className="text-blue-600">
                <i className="fas fa-map-marker-alt"></i>
              </span>
              <p className="text-sm sm:text-base"><strong>Address:</strong> The Federal Polytechnic, Bida, Niger State</p>
            </div>
            <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-blue-50 transition-all duration-300 cursor-pointer transform hover:scale-105">
              <span className="text-blue-600">
                <i className="fas fa-envelope"></i>
              </span>
              <p className="text-sm sm:text-base"><strong>Email:</strong> registry@fedpolybida.edu.ng</p>
            </div>
            <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-blue-50 transition-all duration-300 cursor-pointer transform hover:scale-105">
              <span className="text-blue-600">
                <i className="fas fa-phone"></i>
              </span>
              <p className="text-sm sm:text-base"><strong>Phone:</strong> +2348138644342</p>
            </div>
            <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-blue-50 transition-all duration-300 cursor-pointer transform hover:scale-105">
              <span className="text-blue-600">
                <i className="fas fa-clock"></i>
              </span>
              <p className="text-sm sm:text-base"><strong>Working Hours:</strong> Mon-Fri: 8AM - 5PM, Sat: 9AM - 1PM</p>
            </div>
          </div>
        </div>


        {/* Form & Map Section */}
        <div className="w-full lg:w-3/5 space-y-8">

          {/* Contact Form */}
          <div
            ref={formRef}
            className={`bg-white rounded-3xl shadow-2xl p-6 md:p-10 mb-8 transition-all duration-700 ${
              formVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-6 flex items-center gap-3">
              <span className="bg-indigo-100 text-indigo-600 w-10 h-10 flex items-center justify-center rounded-full shadow-md">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12h2m-1-1v2m-4-1h.01M8 12h.01M12 16h.01M12 8h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z" />
                </svg>
              </span>
              Send Us a Message
            </h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input name="name" value={formData.name} onChange={handleChange} placeholder="Full Name" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 transition" />
                <input name="email" value={formData.email} onChange={handleChange} placeholder="Email" type="email" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 transition" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone Number" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 transition" />
                <input name="subject" value={formData.subject} onChange={handleChange} placeholder="Subject" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 transition" />
              </div>
              <textarea name="message" value={formData.message} onChange={handleChange} rows="5" placeholder="Your Message" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500 transition"></textarea>
              <button type="submit" className="w-full bg-gradient-to-r from-indigo-600 to-blue-600 text-white py-3 rounded-lg font-semibold text-lg hover:opacity-90 transition shadow-md">
                Send Message
              </button>
            </form>
            {isSubmitted && (
              <div className="mt-6 p-4 bg-green-50 text-green-700 rounded-lg border border-green-200">
                Thank you! We'll get back to you within 24 hours.
              </div>
            )}
          </div>

          {/* Map Section */}
          <div
            ref={mapRef}
            className={`bg-white rounded-3xl shadow-2xl p-6 transition-all duration-700 ${
              mapVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4 flex items-center gap-3">
              <span className="bg-green-100 text-green-600 w-10 h-10 flex items-center justify-center rounded-full shadow-md">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13 21.314l-4.657-4.657A8 8 0 1117.657 16.657z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </span>
              Find Us
            </h2>
            <iframe
              title="campus-map"
              className="w-full h-64 md:h-72 rounded-2xl shadow"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3950.105926165234!2d6.0053428!3d9.0391069!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104966b7f2e9b195%3A0x18c8eec7a2fae37c!2sFederal%20Polytechnic%2C%20Bida!5e0!3m2!1sen!2sng!4v1684567890123!5m2!1sen!2sng"
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Floating Social Buttons */}
      <div className={`hidden sm:flex fixed left-0 top-1/3 flex-col space-y-4 z-50 transition-transform duration-300 ${showSocials ? "translate-x-0" : "-translate-x-32"}`}>
        {socials.map((social, idx) => (
          <a
            key={idx}
            href={social.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`${social.color} text-white p-3 rounded-r-lg shadow-lg hover:${social.hover} transition transform hover:scale-110 hover:-translate-x-2 flex items-center group relative`}
            style={{
              transitionDelay: `${idx * 100}ms`,
              transitionProperty: 'opacity, transform',
              opacity: showSocials ? 1 : 0,
              transform: showSocials ? 'translateX(0)' : 'translateX(-3rem)'
            }}
          >
            {social.icon}
            <span className="absolute left-full ml-2 bg-gray-900 text-white text-sm font-medium px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transform -translate-x-3 group-hover:translate-x-0 transition-all duration-300 whitespace-nowrap">
              {social.name}
            </span>
          </a>
        ))}
      </div>

      {/* Floating Chat Buttons */}
      <div
        className={`fixed bottom-6 right-6 flex flex-col gap-4 z-50 transition-all duration-500 ${
          showSocials ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}
      >
        {chatButtons.map((btn, idx) => (
          <a
            key={idx}
            href={btn.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`${btn.color} text-white p-4 rounded-full shadow-lg hover:${btn.hover} transform hover:scale-110 transition-all animate-bounce`}
            style={{ animationDelay: `${idx * 0.3}s` }}
          >
            {btn.icon}
          </a>
        ))}
      </div>
    </div>
  );
};

export default Contact;
